const daysTo = (startDate, endDate) => {
  let diffInDays = startDate.diff(endDate, 'days', true)
  if (diffInDays <= 0) {
    return 'Sucedido'
  }

  if (diffInDays < 0.1) {
    const diffInHours = startDate.diff(endDate, 'hours', true)
    if (diffInHours < 1) {
      const diffInMinutes = Math.ceil(startDate.diff(endDate, 'minutes', true))

      return `En ${diffInMinutes} minutos`
    }

    return `En ${diffInHours} horas`
  }

  diffInDays = Math.ceil(diffInDays)

  if (diffInDays === 1) {
    return 'Mañana'
  }

  return `En ${diffInDays} días`
}

export default daysTo
